<template>
  <div id="ranking_family" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <van-row>
      <van-col span="24" :class="isFull === 1 ? 'ranking_family_top_bg top_information':'ranking_family_top_bg'">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              class="ranking_family_top_bg_bar"
              @click-left="onClickLeft"
          >
            <template #title>
              <van-tabs v-model="ranking_active" @click="onClickRankingActive" @disabled="onClickDisabled" line-width="20px" title-active-color="#ffffff" title-inactive-color="#9B9CBF">
                <van-tab :title="$t('title.month_statistics_log')" name="1"/>
                <van-tab :title="$t('column.my_family')" name="2" disabled/>
              </van-tabs>
            </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1" class="ranking_family_top_day">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list')" name="day"></van-tab>
            <van-tab :title="$t('column.week_list')" name="week"></van-tab>
            <van-tab :title="$t('column.Monthly_list')" name="month"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1">
          <van-col span="7" class="ranking_family_number">
            <van-col span="22" offset="1" class="ranking_family_number_bg2 ranking_family_number_bg" @click="JumpUserinfo(list.length > 1 ? list[1] : '')">
              <img src="../assets/img/rank/rank2.png" class="ranking_family_number_img2"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="ranking_family_number_avatar"
                  fit="cover"
                  :src="list[1].head_image"
                  v-if="list.length > 1"
              />
              <van-col span="22" offset="1" class="ranking_family_number_name"> {{ list.length > 1 ? list[1].family_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_family_number_coin">{{ list.length > 1 ? list[1].sums : '' }}</van-col>
            </van-col>
          </van-col>
          <van-col span="10" class="ranking_family_number">
            <van-col span="20" offset="2" class="ranking_family_number_bg1 ranking_family_number_bg" @click="JumpUserinfo(list.length > 0 ? list[0] : '')">
              <img src="../assets/img/rank/rank1.png" class="ranking_family_number_img"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="ranking_family_number_avatar"
                  fit="cover"
                  :src="list[0].head_image"
                  v-if="list.length > 0"
              />
              <van-col span="22" offset="1" class="ranking_family_number_name">{{ list.length > 0 ? list[0].family_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_family_number_coin"> {{ list.length > 0 ? list[0].sums : '' }} </van-col>

            </van-col>
          </van-col>
          <van-col span="7" class="ranking_family_number">
            <van-col span="22" offset="1" class="ranking_family_number_bg3 ranking_family_number_bg" @click="JumpUserinfo(list.length > 2 ? list[2] : '')">
              <img src="../assets/img/rank/rank3.png" class="ranking_family_number_img2"/>
              <van-image
                  width="12vw"
                  height="12vw"
                  round
                  class="ranking_family_number_avatar"
                  fit="cover"
                  :src="list[2].head_image"
                  v-if="list.length > 2"
              />
              <van-col span="22" offset="1" class="ranking_family_number_name">{{ list.length > 2 ? list[2].family_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_family_number_coin">  {{ list.length > 2 ? list[2].sums : '' }}  </van-col>

            </van-col>
          </van-col>
        </van-col>

      </van-col>
      <van-col span="24" class="ranking_user_list">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoad"
        >
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
            <van-col span="24" class="ranking_family_list_item">
              <van-col span="3" offset="1" class="ranking_family_list_item_number">{{ i + 1 }}</van-col>
              <van-col span="4" class="ranking_family_list_item_avatar">
                <van-image
                    width="10vw"
                    height="10vw"
                    round
                    :src="item.head_image"
                    fit="cover"
                    @click="JumpUserinfo(item)"
                />
              </van-col>
              <van-col span="9" class="ranking_family_list_item_user_name"> {{ item.family_name }} </van-col>
              <van-col span="6" class="ranking_family_list_item_coin">{{ item.sums }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
    <van-overlay :show="loading"  class="overlay_loading">
      <van-loading type="spinner"/>
    </van-overlay>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import SVGA from "svgaplayerweb";

export default {
  data() {
    return {
      day_active: 'day',
      ranking_active: '1',
      list: [],
      finished: false,
      loading: false,
      page: 1,
      my_family_id: 0,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      loading_request: false, // 接口是否在请求中
      touchStartX: 0, // 触摸开始X坐标
      touchStartY: 0, // 触摸开始Y坐标
      touchEndX: 0, // 触摸结束X坐标
      touchEndY: 0, // 触摸结束Y坐标
      day_tabs: ['day', 'week', 'month'] // 时间tab顺序
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.convert()
  },
  methods: {
    onClickDisabled() {
      console.log('禁止')
      window.location.href="live://live?action=JumpMyFamily"
    },
    onClickRankingActive(name, title) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.convert()
    },
    onClickRankingDay(name) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.day_active = name
      this.finished = false;
      this.page = 1
      this.list = []
      this.convert()
    },
    // 触摸开始
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    // 触摸移动
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX
      this.touchEndY = e.touches[0].clientY
    },
    // 触摸结束
    handleTouchEnd() {
      // 如果接口正在请求中，禁止滑动切换
      if (this.loading_request) {
        return
      }
      
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      
      // 判断是否为水平滑动（水平移动距离大于垂直移动距离，且大于50px）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const currentIndex = this.day_tabs.indexOf(this.day_active)
        
        if (deltaX > 0) {
          // 向右滑动，切换到上一个tab
          if (currentIndex > 0) {
            this.day_active = this.day_tabs[currentIndex - 1]
            this.finished = false
            this.page = 1
            this.list = []
            this.convert()
          }
        } else {
          // 向左滑动，切换到下一个tab
          if (currentIndex < this.day_tabs.length - 1) {
            this.day_active = this.day_tabs[currentIndex + 1]
            this.finished = false
            this.page = 1
            this.list = []
            this.convert()
          }
        }
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    JumpUserinfo(item) {
      console.log(item)
      if(item){
        // 拦截跳转家族页面
        window.location.href="live://live?action=JumpFamily&id=" + item.id + '&name=' + item.family_name
      }
    },
    onLoad() {
      if(this.page > 1){
        // 异步更新数据
        this.convert()
      }
    },
    convert() {
      // 标记接口开始请求
      this.loading_request = true
      
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=family&act=guild_ranking", {
        params : {
          token: token,
          type: this.day_active,
          page: this.page
        }
      }).then(res =>{
        this.loading = false
        this.loading_request = false // 标记接口请求完成
        
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.my_family_id = res.data.family_id
        if(this.page<=1) {
          this.list = res.data.data
        }else{
          for(let i = 0; i< res.data.data.length; i ++) {
            this.list.push(res.data.data[i])
          }
        }
        //数据全部加载完成
        if (res.data.data.length < 1) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.page ++
      }).catch(err => {
        this.loading = false
        // 请求失败也要恢复状态
        this.loading_request = false
        Toast(this.$t('other.network_error') || '网络错误')
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/ranking_family.vue